<template>
  <div class="vue-map-info-modal-wrap">
    <div>
      <b-modal
      hide-footer
      id="map-info-modal"
      @hide="cancel"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>Map Info</h3>
        </template>
        <div class="content-container">
          <div class="content">
            <section>
                <h4>Legend</h4>
                <div class="sub-section">
                  <div class="item">
                    <p>Utilities, counties and towns are shaded according to how many customers have power out.</p>
                    <ul class="legend-items">
                      <li class="legend-item">
                        <span class="color-block" :style="{ backgroundColor: outageColors.one }"></span>
                        <span class="avatar">
                          <img src="../../../assets/img/user-menu-icon-profile.png" />
                        </span>
                        <span class="count">1-99 customers out</span>
                      </li>
                      <li class="legend-item">
                        <span class="color-block" :style="{ backgroundColor: outageColors.oneHundred }"></span>
                        <span class="avatar">
                          <img src="../../../assets/img/user-menu-icon-profile.png" />
                        </span>
                        <span class="count">100-249 customers out</span>
                      </li>

                      <li class="legend-item">
                        <span class="color-block" :style="{ backgroundColor: outageColors.twoFifty }"></span>
                        <span class="avatar">
                          <img src="../../../assets/img/user-menu-icon-profile.png" />
                        </span>
                        <span class="count">250-499 customers out</span>
                      </li>

                      <li class="legend-item">
                        <span class="color-block" :style="{ backgroundColor: outageColors.fiveHundred }"></span>
                        <span class="avatar">
                          <img src="../../../assets/img/user-menu-icon-profile.png" />
                        </span>
                        <span class="count">500-999 customers out</span>
                      </li>

                      <li class="legend-item">
                        <span class="color-block" :style="{ backgroundColor: outageColors.oneThousand }"></span>
                        <span class="avatar">
                          <img src="../../../assets/img/user-menu-icon-profile.png" />
                        </span>
                        <span class="count">1,000+ customers out</span>
                      </li>

                    </ul>
                  </div>
                </div>
            </section>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueMqMixin from "../mixins/VueMqMixin";
import { outageColors } from "../../../resources/outagePalette.js";

export default {
  name: 'MapInfoModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    userIsAdmin: Boolean,
    hideModal: Function
  },
  async created() {
    Vue.nextTick(async () => this.showModal());
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal map-info isMobileOrTablet'] : ['vt-outages-modal map-info'];
  },
  data() {
    return {
      outageColors
    }
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      async showModal() {
        await this.$bvModal.show('map-info-modal');
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

#map-info-modal{
  .content-container{
    overflow-y: scroll;

    .content{
      section {
        padding: 10px;
        background-color: $lightGrey;

        h4 {
          font-weight: $bold;
          font-size: 22px;
        }

        .item{
          padding: 10px;
          background-color: $white;

          h5 {
            font-weight: $bold;
            font-size: 18px;
          }

          p{
            padding: 10px;
            background-color: $white;
          }

          .legend-items {
            margin-left: 20px;
            list-style-type: none;

            .legend-item{
              list-style-type: none;
              margin: 0 0 10px 0;
              padding: 0;
              line-height: 18px;

              .color-block {
                position: relative;
                display: inline-block;
                width: 100px;
                height: 20px;
                margin-right: 10px;
                border-radius: 20px;
                top: 5px;

              }

              .avatar {
                margin-right: 10px;

                img {
                  width: 18px;
                }
              }

              .count {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
